import React from 'react'
import PropTypes from 'prop-types'
import Drawer from 'components/common/Drawer'
import Media from 'components/common/Media'
import { H1 } from 'components/common/Text/Text'
import PersonalInformationDrawer from '../PersonalInformationDrawer'
import PasswordAndSecurityDrawer from '../PasswordAndSecurityDrawer'
import CommunicationPreferencesDrawer from '../CommunicationPreferencesDrawer'
import StoreLocator from '../StoreLocator'
import * as UI from '../Shared.styles'

const BOTAccountPersonalInformation = ({
  accountDetails: {
    accountContactDetails,
    accountContactDetails: {
      emailId
    } = {},
    accountInformation: {
      communicationsPreferences: {
        appointmentReminder,
        savingAndDiscounts
      } = {},
      states: {
        states = []
      } = {},
      storeType
    } = {}
  } = {},
  flags,
  toggleFlagHandler,
  findMyStoreInstruction,
  ...props
}) =>
  <React.Fragment>
    <H1 noMargin>
      <Media.ScreenReader>Account Details</Media.ScreenReader>
    </H1>
    <UI.Tab data-at-myaccount-accountdetails>
      <PersonalInformationDrawer
        accountContactDetails={ accountContactDetails }
        states={ states } />
      <PasswordAndSecurityDrawer accountContactDetails={ accountContactDetails } />
      <CommunicationPreferencesDrawer
        { ...props }
        accountContactDetails={ accountContactDetails }
        appointmentReminder={ appointmentReminder }
        savingAndDiscounts={ savingAndDiscounts } />
      <Drawer title="My Saved Location" withHeading accordion>
        <StoreLocator findMyStoreInstruction={ findMyStoreInstruction } />
      </Drawer>
    </UI.Tab>
  </React.Fragment>

export default BOTAccountPersonalInformation

BOTAccountPersonalInformation.propTypes = {
  accountDetails: PropTypes.shape({
    accountContactDetails: PropTypes.object,
    accountInformation: PropTypes.object,
    loginDetails: PropTypes.any
  }),
  findMyStoreInstruction: PropTypes.string,
  flags: PropTypes.shape(),
  name: PropTypes.string,
  status: PropTypes.string,
  storeType: PropTypes.shape(),
  toggleFlagHandler: PropTypes.func
}
